var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack1130({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.6,9.8c2.2,0,2.2,1.91,4.41,1.91s2.2-1.91,4.4-1.91A3.7,3.7,0,0,1,15,11.08V5a3.67,3.67,0,0,0-2.59-1.28c-2.2,0-2.2,1.91-4.4,1.91S5.8,3.71,3.6,3.71C2.24,3.71,1.72,4.44,1,5v6.1C1.72,10.53,2.24,9.8,3.6,9.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack1130);
export default __webpack_public_path__ + "static/media/Symbolpack_1_130.cc5c47d495acfe37d3d97af87d6f9259.svg";
export { ForwardRef as ReactComponent };